import { useNavigate, useParams } from 'react-router-dom'

import { useUser } from '@contexts'
import { ROUTE_KEYS } from '@constants'

import LoadingSpinner from '../../components/LoadingSpinner'

const TicketRouter = () => {
  const { state: user } = useUser()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()

  navigate(
    id ? `${ROUTE_KEYS[user!.roles[0].name].TICKET}/${id}` : ROUTE_KEYS[user!.roles[0].name].HOME,
  )

  return <LoadingSpinner />
}

export default TicketRouter
